module.exports = __webpack_public_path__ + "img/bank.ca806fcf.svg";